import { VALUES_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getValues = (data) => ({
    type: VALUES_GET_LIST,
    payload: data
});
